import { URL_BASE } from "./constants";
import { get, handleErrors, post, deleteRequest, put, patch } from "./requests";
import { Store } from "../redux/store";
import { loadUsers } from "../redux/actions/usersActions";
import { showSuccess, showWarning } from '../redux/actions/snackbarActions';

async function getAllUsers() {
    const url = `${URL_BASE}/account/users`;
    const users = await get(url);
    Store.dispatch(loadUsers(users.data));
    return users.data;
}

async function getCouponsAmount() {
    const url = `${URL_BASE}/coupons/initial/amount`;
    const payload = await get(url);
    return payload.data;
}

async function setCouponsAmount(couponsAmount) {
    const url = `${URL_BASE}/coupons/initial/amount?couponAmount=${couponsAmount}`;
    const payload = await patch(url);
    if (payload.success) {
        Store.dispatch(showSuccess('Coupon\'s amount updated successfully.'));
    }
    return payload.data;
}

async function addUser(fullName, emailAddress, phoneNumber, zipCode, password, role, idCompany) {
    const user = {
        fullName,
        emailAddress,
        phoneNumber,
        zipCode,
        password,
        idCompany
    };
    const url = `${URL_BASE}/account/create/${role === 'COMPANY' ? 'company' : 'administrator'}`;

    await post(url, user, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    await getAllUsers();
}


async function updateUser(id, fullName, emailAddress, phoneNumber, zipCode) {
    const user = {
        id,
        fullName,
        email: emailAddress,
        phoneNumber,
        zipCode,
        
    };
    const url = `${URL_BASE}/account/edit`;

    await put(url, user, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    Store.dispatch(showSuccess('User updated successfully!'));
    await getAllUsers();
}

async function statusUser(id, statusUser){
    const url =`${URL_BASE}/account/change-status-user?idUser=${id}`;
    const token = Store.getState().authState.loggedUser;
    const res = await patch(url, null, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data, statusText } = error;
        Store.dispatch(showWarning(`${statusText}`));
        handleErrors(status, data);
    });

    if(res){
        if(statusUser){
            Store.dispatch(showSuccess('The account has been activated!'));
        }else{
            Store.dispatch(showSuccess('The account has been disabled!'));
        }
        
    }
    await getAllUsers();
}

async function deleteUser(id) {
    const url = `${URL_BASE}/account/delete?idUser=${id}`;
    await deleteRequest(url, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    await getAllUsers();
}

export default {
    getAllUsers,
    getCouponsAmount,
    setCouponsAmount,
    addUser,
    deleteUser,
    updateUser,
    statusUser
};